export enum ALERT_CONSTANTS {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}
